module.exports = __webpack_public_path__ + "static/media/typicons.29f9630f.ttf";